import { IImgCaptionOption } from '../../interface/Element'

export const defaultImgCaptionOption: Readonly<Required<IImgCaptionOption>> = {
  color: '#666666',
  font: 'Microsoft YaHei',
  size: 12,
  top: 5
}